import { Component } from '@angular/core';
import { Platform, App, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { MobileAccessibility } from '@ionic-native/mobile-accessibility';

// import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
    //// 인트로(스플래시)를 최소 이만큼은 띄운다. config.xml 의 SplashScreenDelay(3000) 가 상한이다.
    static readonly INTRO_MIN_MS = 2000;

    rootPage:any = LoginPage;

	messages = [];
	nickname = '';
	message = '';
	forward: boolean = true;

	public language: string;

	constructor(
		public platform: Platform,
		public app: App,
		private statusBar: StatusBar,
		private splashScreen: SplashScreen,
		private mobileAccessibility: MobileAccessibility,
		// private toastCtrl: ToastController,
        // private alertCtrl: AlertController,
		// private socket: Socket,
		// private localNotifications: LocalNotifications,
		public events: Events
	) {
		this.initializeApp();

		// this.getMessages().subscribe(message => {
		// 	this.messages.push(message);
		// });
	
		// this.getUsers().subscribe(data => {
		// 	console.log(data['user']);
		// 	let user = data['user'];
		// 	if (data['event'] === 'left') {
		// 		this.showToast('User left: ' + user);
		// 	} else {
		// 		this.showToast('User joined: ' + user);
		// 	}
		// });
	}

	initializeApp() {
		this.platform.ready().then(() => {
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.
			// this.statusBar.backgroundColorByHexString('#eb2a25');
			this.statusBar.overlaysWebView(true);
			// this.statusBar.styleBlackOpaque();
			this.statusBar.styleDefault();

			this.mobileAccessibility.setTextZoom(100); //기본 폰트 줌 설정
			this.mobileAccessibility.usePreferredTextZoom(false); // 시스템 글자 크기 사용여부 설정

			this.platform.registerBackButtonAction(() => {
				if(localStorage.getItem("pageName") === "login"){
					this.platform.exitApp();
				} else if(localStorage.getItem("pageName") === "pointmenu" || localStorage.getItem("pageName") === "wallet" || localStorage.getItem("pageName") === "sendbc" || localStorage.getItem("pageName") === "mypage" || localStorage.getItem("pageName") === "paycomplete") {
					let navCtrl = this.app.getActiveNavs()[0];
					navCtrl.parent.select(0);
					return;
				} else {
					let navCtrl = this.app.getActiveNavs()[0];
					// let activeView = navCtrl.getActive();
					if (navCtrl.canGoBack()) {
						navCtrl.pop();
					}
				}
			});

			//// 2026-09-21: 인트로가 안 보인다는 지적.
			//// platform.ready() 는 보통 1초도 안 걸려서 여기서 바로 hide() 를 부르면
			//// config.xml 의 SplashScreenDelay(3000) 가 통째로 무의미해진다 - 인트로가
			//// 화면에 뜨자마자 사라진다. 앱이 준비돼도 최소 이 시간만큼은 보여준다.
			//// 상한은 그대로 3초다(Cordova 의 AutoHideSplashScreen 이 알아서 닫는다).
			setTimeout(() => this.splashScreen.hide(), MyApp.INTRO_MIN_MS);

			
			this.platform.resume.subscribe(() => {
				this.forward = true;
			});  
			this.platform.pause.subscribe(() => {
				this.forward = false;
			});
			
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts